import React, { useEffect, useState } from 'react';
import api, { isSupervisorRole, getCurrentUser } from '../api/expoApi';

export default function Integrations() {
    const user = getCurrentUser();
    const isSupervisor = isSupervisorRole(user?.role);
    const [items, setItems] = useState([]);
    const [selected, setSelected] = useState(null);
    const [events, setEvents] = useState([]);
    const [newInt, setNewInt] = useState({ provider: 'SHOPIFY', name: '', api_url: '', api_key: '', api_secret: '' });
    const [webhookUrl, setWebhookUrl] = useState('');
    const [msg, setMsg] = useState('');

    const load = async () => {
        try { const r = await api.get('/integrations'); setItems(r.data?.data || []); }
        catch (e) { console.error(e); }
    };

    const loadEvents = async (id) => {
        try {
            const [e, w] = await Promise.all([
                api.get(`/integrations/${id}/events`),
                api.get(`/integrations/${id}/webhook-url`)
            ]);
            setEvents(e.data?.data || []);
            setWebhookUrl(w.data?.data?.webhook_url || '');
        } catch (err) { console.error(err); }
    };

    useEffect(() => { load(); }, []);
    useEffect(() => { if (selected) loadEvents(selected); }, [selected]);

    if (!isSupervisor) return <div style={{ padding: 24 }}><h1>Access denied</h1></div>;

    const create = async () => {
        try {
            const r = await api.post('/integrations', newInt);
            setMsg(`Created. Webhook URL: ${r.data?.webhook_url}`);
            setNewInt({ provider: 'SHOPIFY', name: '', api_url: '', api_key: '', api_secret: '' });
            load();
        } catch (e) { setMsg(e.response?.data?.message || 'Error'); }
    };

    const toggle = async (item) => {
        try {
            await api.put(`/integrations/${item.integration_id}`, { is_active: !item.is_active });
            load();
        } catch (e) { setMsg(e.response?.data?.message || 'Error'); }
    };

    return (
        <div style={{ padding: 24 }}>
            <h1>Integrations</h1>
            {msg && <div style={{ background: '#d1e7dd', padding: 8, borderRadius: 4, marginBottom: 12 }}>{msg}</div>}

            <div style={{ background: '#f8f9fa', padding: 16, borderRadius: 6, marginBottom: 16 }}>
                <h3>Add Integration</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
                    <select value={newInt.provider} onChange={(e) => setNewInt({...newInt, provider: e.target.value})}>
                        <option value="SHOPIFY">Shopify</option>
                        <option value="WOOCOMMERCE">WooCommerce</option>
                        <option value="WORDPRESS">WordPress</option>
                        <option value="CUSTOM">Custom (HMAC SHA-256)</option>
                    </select>
                    <input placeholder="Name (e.g. Main Shop)" value={newInt.name} onChange={(e) => setNewInt({...newInt, name: e.target.value})} />
                    <input placeholder="API URL" value={newInt.api_url} onChange={(e) => setNewInt({...newInt, api_url: e.target.value})} />
                    <input placeholder="API Key" value={newInt.api_key} onChange={(e) => setNewInt({...newInt, api_key: e.target.value})} />
                    <input placeholder="API Secret" type="password" value={newInt.api_secret} onChange={(e) => setNewInt({...newInt, api_secret: e.target.value})} />
                </div>
                <button onClick={create} style={{ marginTop: 8, padding: '8px 16px' }}>Create</button>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', marginBottom: 24 }}>
                <thead><tr><th>Provider</th><th>Name</th><th>Hub</th><th>Active</th><th>Last Sync</th><th>Events 7d</th><th>Actions</th></tr></thead>
                <tbody>
                    {items.map((i) => (
                        <tr key={i.integration_id}>
                            <td>{i.provider}</td>
                            <td>{i.name}</td>
                            <td>{i.hub_code || '—'}</td>
                            <td>{i.is_active ? '✓' : '—'}</td>
                            <td>{i.last_sync_at ? new Date(i.last_sync_at).toLocaleString() : 'Never'}</td>
                            <td>{i.events_7d}</td>
                            <td>
                                <button onClick={() => setSelected(i.integration_id)}>View</button>
                                <button onClick={() => toggle(i)}>{i.is_active ? 'Disable' : 'Enable'}</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {selected && (
                <>
                    <h3>Recent Events</h3>
                    <div style={{ background: '#fff3cd', padding: 12, borderRadius: 4, marginBottom: 12 }}>
                        <strong>Webhook URL (configure in your shop):</strong><br />
                        <code style={{ wordBreak: 'break-all' }}>{webhookUrl}</code>
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
                        <thead><tr><th>When</th><th>Direction</th><th>Type</th><th>External ID</th><th>Status</th></tr></thead>
                        <tbody>
                            {events.map((e) => (
                                <tr key={e.event_id}>
                                    <td>{new Date(e.created_at).toLocaleString()}</td>
                                    <td>{e.direction}</td>
                                    <td>{e.event_type}</td>
                                    <td>{e.external_id}</td>
                                    <td style={{ color: e.status === 'PROCESSED' ? '#198754' : e.status === 'FAILED' ? '#dc3545' : '#6c757d' }}>
                                        {e.status}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
}
